const Filters = {
  /** 是否置顶 */
  isTop: function (status) {
    if (status === true) {
      return '是';
    } else {
      return '否';
    }
  },

  /** 渠道状态  1=现货仓=》实仓  2=非现货仓=》虚仓 */
  channeltype: function (type) {
    if (type === 1) {
      return '实仓';
    } else {
      return '虚仓';
    }
  },

  /** 锁定状态  1=启用 2=停用 */
  lockstatus: function (status) {
    if (status === 1) {
      return '启用';
    } else {
      return '停用';
    }
  },

  /** 是否包邮 */
  isfreeship: function (status) {
    if (status) {
      return '是';
    } else {
      return '否';
    }
  },

  /** 状态——是否启用=1，停用=2  //  上架=1，下架=2 */
  status: function (state) {
    if (state === 1) {
      return '是';
    } else {
      return '否';
    }
  },

  /** 货品卖或送类型 卖=1， 送=2 */
  sellorsend: function (type) {
    if (type === 1) {
      return '卖';
    } else {
      return '送';
    }
  },

  /** 允许售后 */
  aftersale: function(type) {
    if (type) {
      return '是';
    } else {
      return '否';
    }
  },

  /** 时间日期格式转换---年月日 */
  timeday: function (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      return y + '/' + M + '/' + d;
    } else {
      return '';
    }
  },

  /** 时间格式转换 */
  time: function (times) {
    if (times) {
      const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      const h = twoDigits(dtime.getHours());
      const m = twoDigits(dtime.getMinutes());
      const s = twoDigits(dtime.getSeconds());
      return y + '/' + M + '/' + d + ' ' + h + ':' + m + ':' + s;
    } else {
      return '';
    }
  },

  /** 时间日期格式转换 */
  timedate: function (times) {
    if (times) {
     /* const dtime = new Date(times);
      const y = dtime.getFullYear();
      const M = twoDigits(dtime.getMonth() + 1);
      const d = twoDigits(dtime.getDate());
      const h = twoDigits(dtime.getHours());
      const m = twoDigits(dtime.getMinutes());
      const s = twoDigits(dtime.getSeconds());
      return (y.toString()).slice(2) + '/' + M + '/' + d + ' ' + h + ':' + m + ':' + s; */
      // times.splice(4,5);
     // times.splice(6,7);

     /* const dateJson = new Date(times).toJSON();
      const dateOld = new Date(+new Date(dateJson)).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'');
      const dateNew = dateOld.replace(/-/g, '/');
      return dateNew; */

      const Y = times.substr(0, 4);
      const M = times.substr(5, 2);
      const D = times.substr(8, 2);
      const h = times.substr(11, 2);
      const m = times.substr(14, 2);
      const s = times.substr(17, 2);
      return Y + '/' + M + '/' + D + ' ' + h + ':' + m + ':' + s;
    } else {
      return '';
    }
  },

  /** 性别：1=男  2=女 3=中 */
  gender: function (gender) {
    if (gender === 1) {
      return '男性';
    } else if (gender === 2) {
      return '女性';
    } else if (gender === 3) {
      return '中性';
    } else if (gender === 4) {
      return '童';
    }
  },

  /** 库存对接状态 */
  inventorydocking: function (status) {
    if (status === 1) {
      return '开启';
    } else {
      return '关闭';
    }
  },

  /** 是否今日发货  1=是  2=否 */
  istodaydelivery: function (status) {
    if (status === 1 || status === true) {
      return '是';
    } else {
      return '否';
    }
  },

  /** 货品发布状态 */
  publishstatus: function (status) {
    if (status === 1) {
      return '已发布';
    } else {
      return '未发布';
    }
  },

  /** 货品上架状态 */
  onstate: function (status) {
    if (status === 1) {
      return '已上架';
    } else if (status === 2) {
      return '部分上架';
    } else if (status === 3) {
      return '已下架';
    } else {
      return '已下架';
    }
  },

  /** 链接上架状态 */
  onstatelink: function (status) {
    if (status === 1) {
      return '上架';
    } else if (status === 2) {
      return '下架';
    }
  },

  /** 链接库存对接状态 */
  inventorydockinglink: function (status) {
    if (status === 1) {
      return '开启';
    } else if (status === 2) {
      return '关闭';
    } else {
      return '';
    }
  },

  /** 平台状态 */
  plateformstatus: function (status) {
    if (status === 1) {
      return '待审';
    } else if (status === 2) {
      return '正常';
    } else if (status === 3) {
      return '审核状态';
    } else if (status === 4) {
      return '锁定中';
    }
  },

  /** 旗帜 */
  flagtype: function (type) { // 旗帜 灰0 红1 黄2 绿3 蓝4 紫5
    if (type === 1) {
      return 'red';
    } else if (type === 2) {
      return 'yellow';
    } else if (type === 3) {
      return 'green';
    } else if (type === 4) {
      return 'blue';
    } else if (type === 5) {
      return 'purple';
    }
  },

  /** 订单状态 */
  orderstatus: function (status) {
    if (status === 1) {
      return '待审';
    } else if (status === 2) {
      return '配货中';
    } else if (status === 3) {
      return '配货中部分缺货';
    } else if (status === 4) {
      return '配货中缺货';
    } else if (status === 5) {
      // return '待发货';
      return '配货中';
    } else if (status === 6) {
      return '已发货';
    } else if (status === 7) {
      return '交易完成';
    } else if (status === 8) {
      return '交易取消';
    }
  },

  /** 充值类型 */
  rechargetype: function (type) {
    if (type === 1) {
      return '自动充值';
    } else if (type === 2) {
      return '手工充值';
    }
  },

  /** 支付方式 */
  paytype: function (type) {
    if (type === 1) {
      return '支付宝';
    } else if (type === 2) {
      return '银行卡';
    }
  },

  /** 工单状态 */
  rechargeorderstatus: function (type) {
    if (type === 1) {
      return '待审核';
    } else if (type === 2) {
      return '已审核';
    } else if (type === 3) {
      return '拒绝申请';
    }
  },

  /** 申诉工单状态 */
  complaintorderstatus: function (type) {
    if (type === 1) {
      return '待提交';
    } else if (type === 2) {
      return '待审核';
    } else if (type === 3) {
      return '已完成';
    } else if (type === 4) {
      return '拒绝受理';
    }
  },

  /** 资金流水状态 */
  capitalflowstatus: function (type) {
    if (type === 1) {
      return '账户充值';
    } else if (type === 2) {
      return '账户提现';
    } else if (type === 3) {
      return '购物支出';
    } else if (type === 4) {
      return '发货收入';
    } else if (type === 5) {
      return '缺货退款';
    } else if (type === 6) {
      return '售后退款';
    } else if (type === 7) {
      return '申诉退款';
    } else if (type === 8) {
      return '平台增扣款';
    } else if (type === 9) {
      return '购物取消退款';
    }
  },

  /** 数据下载之是否停用 IsStop */
  isstop: function (status) {
    if (status === 1) {
      return '是';
    } else {
      return '否';
    }
  }
};

/* 单位数转两位数 */
function twoDigits(digits) {
  if (digits >= 0 && digits < 10) {
    return '0' + digits;
  } else {
    return digits;
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/assets/js/filter.js